import * as React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@workspace/ui/components/accordion';

import { TRIAL_FAQ_ANSWER, TRIAL_FAQ_QUESTION } from '../trial';

export const PRICING_FAQ = [
  {
    question: 'Do I need a credit card to start the free trial?',
    answer:
      'Yes — a card is required to start your 7-day free trial, but you pay $0 today. Cancel anytime before the trial ends and you won’t be charged. If you pick an annual plan, your first invoice after the trial is the full year.'
  },
  {
    question: TRIAL_FAQ_QUESTION,
    answer: TRIAL_FAQ_ANSWER
  },
  {
    question: 'What happens when the launch offer ends?',
    answer:
      'Your discounted rate applies for your first 6 months. After that, your plan renews at the standard price shown on this page.'
  },
  {
    question: 'Can I change or cancel my plan later?',
    answer:
      'Yes — upgrade, downgrade, or cancel anytime from Billing → Manage Subscriptions. Changes are prorated to your billing cycle.'
  },
  {
    question: 'Is annual cheaper than monthly?',
    answer:
      'For most plans, yes — annual billing lowers your effective monthly rate versus paying month to month. Switch the toggle above to compare.'
  },
  {
    question: 'What counts as a render, a minute, or an avatar minute?',
    answer:
      'A render is one export of a finished video. Cloud renders count toward your monthly render quota; local renders — exported right in your browser on paid plans — are free and unlimited. Upload and AI-voice minutes measure the footage you bring in and the narration we generate each month. Avatar minutes are footage featuring an AI presenter. Unused amounts don’t roll over.'
  },
  {
    question: 'How do avatar credits and quality tiers work?',
    answer:
      'Every plan includes avatar minutes each month — 3 on Creator, 8 on Team, and 20 on Agency. Avatar credits burn per minute of avatar video, at a rate set by the avatar’s type and the quality tier you pick: from 1 credit-minute (a studio avatar on Normal) up to 4 (High Quality, and digital twins on any tier). All three tiers render at 1080p, so the tier changes fidelity and burn rate, not resolution. Credit packs and add-ons top up both avatar minutes and custom avatar slots whenever you need more.'
  }
];

/** Pricing FAQ accordion shown at the bottom of the pricing page. */
export function PricingFAQ(): React.JSX.Element {
  return (
    <div className="container pb-16">
      <div className="mx-auto max-w-2xl">
        <h2 className="mb-6 text-center text-2xl font-semibold tracking-tight">
          Frequently asked questions
        </h2>
        <Accordion
          type="single"
          collapsible
          className="w-full"
        >
          {PRICING_FAQ.map((item, index) => (
            <AccordionItem
              key={item.question}
              value={`item-${index}`}
            >
              <AccordionTrigger className="text-left text-base font-medium">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
